// react
import { forwardRef } from 'react';

// material ui
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

// components
import stringToColor from '@/utils/stringToColor';

function stringAvatar(name, size) {
  if (!name) return {};

  const firstLetter = name.charAt(0).toUpperCase();

  return {
    sx: {
      bgcolor: stringToColor(name),
      color: 'white',
      width: size,
      height: size,
      fontSize: size <= 32 ? '0.85rem' : '1rem',
      variant: 'round',
    },
    children: firstLetter,
  };
}

/**
 * @type {import('react').ForwardRefExoticComponent<{ string?: string, size?: number } & import('react').RefAttributes<HTMLDivElement>>}
 */
const AvatarComponent = forwardRef((props, ref) => {
  const { string, size = 38, ...rest } = props;
  return (
    <Box position="relative" display="inline-flex">
      {' '}
      {/* Use Box to position Avatar and Icon */}
      <Avatar {...stringAvatar(string, size)} ref={ref} {...rest} />
    </Box>
  );
});
AvatarComponent.displayName = 'AvatarComponent';

AvatarComponent.displayName = 'AvatarComponent';

export default AvatarComponent;
